"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Carousel = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _presentationUtils = require("@ori/presentation-utils");
var _constants = require("./constants");
const Root = exports.Root = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  numberOfSlides
}) => ({
  margin: 'auto',
  maxWidth: `min(calc(${numberOfSlides} * ${_presentationComponents.CATEGORY_BOX_MOBILE_WIDTH}px + ${numberOfSlides - 1} * ${_constants.MOBILE_GAP}px), 600px)`,
  marginBottom: theme.spacing(6),
  [theme.breakpoints.up('sm')]: {
    maxWidth: `min(calc(${numberOfSlides} * ${_presentationComponents.CATEGORY_BOX_DESKTOP_WIDTH}px + ${numberOfSlides - 1} * ${_constants.DESKTOP_GAP}px), 970px)`,
    marginBottom: theme.spacing(20)
  }
}));
const Carousel = exports.Carousel = (0, _mui.styled)(_presentationComponents.Carousel)(({
  theme
}) => ({
  [theme.breakpoints.up('lg')]: {
    margin: theme.spacing(0, -12)
  }
}));
